/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sea_Plane_Fireant_DialInputs */

const fr_sea_plane_fireant_dial = /** @type {(inputs: Sea_Plane_Fireant_DialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification de l'email`)
};

/**

* @param {Sea_Plane_Fireant_DialInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sea_plane_fireant_dial = /** @type {((inputs?: Sea_Plane_Fireant_DialInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sea_Plane_Fireant_DialInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sea_plane_fireant_dial(inputs)
});